import React, { useState, useEffect } from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import TR from './../../Trans';
import dayjs from 'dayjs';
import Tooltip from '@mui/material/Tooltip';
import Countdown from '../player/Countdown';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import PerformanceListItemTime from './PerformanceListItemTime';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import EditIcon from '@mui/icons-material/Edit';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import SvgIcon from '@mui/material/SvgIcon';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Avatar from '@mui/material/Avatar';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import { ReactComponent as EqualizerIcon } from './../../assets/equalizer.svg';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import StarIcon from '@mui/icons-material/Star';
import CancelIcon from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';
import IntervalService from './../../services/intervals';
import SmartQRestore from '../dialogs/SmartQRestore';
import favoritesStore from '../../stores/favorites';
import sessionStore from '../../stores/session';
import settingsStore from '../../stores/settings';
import performanceStore from '../../stores/performance';
import playerStore from './../../stores/player';
import accountStore from '../../stores/account';
import songbookQueueStore from '../../stores/songbookQueue';

function SongbookQueueItem(props) {

  const thisRequest = songbookQueueStore((state) => state.queue?.find(x => x.id == props.reqId));

  const moveToTop = songbookQueueStore((state) => state.moveToTop);
  const moveToSecond = songbookQueueStore((state) => state.moveToSecond);
  const moveToBottom = songbookQueueStore((state) => state.moveToBottom);
  const moveUp = songbookQueueStore((state) => state.moveUp);
  const moveDown = songbookQueueStore((state) => state.moveDown);
  const playQueue = performanceStore((state) => state.playQueue);
  const history = songbookQueueStore((state) => state.history);
  const queue = songbookQueueStore((state) => state.queue);

  const [anchorEl, setAnchorEl] = useState(null);
  const [isMenuOpen, setMenuOpen] = useState(false);

  const handleMenuClose = () => {
    setMenuOpen(false);
  };

  const openMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleMoveToTop = () => {
    console.log("handleMoveToTop", props.reqId);
    moveToTop(props.reqId);
  };

  const handleMoveToSecond = () => {
    moveToSecond(props.reqId);
  };

  const handleMoveToBottom = () => {
    moveToBottom(props.reqId);
  };

  const handleMoveUp = () => {
    moveUp(props.reqId);
  };

  const handleMoveDown = () => {
    moveDown(props.reqId);
  };

  const renderMoveToFirst = () => {
    if (props.index > 0) {
      return <MenuItem onClick={(e) => {
        e.stopPropagation();
        handleMoveToTop();
        handleMenuClose();
      }}>{TR.cm_move_to_top}</MenuItem>;
    }
  };

  const renderMoveToSecond = () => {
    if (props.count > 1 && props.index != 1) {
      return <MenuItem onClick={(e) => {
        e.stopPropagation();
        handleMoveToSecond();
        handleMenuClose();
      }}>{TR.cm_move_to_second}</MenuItem>;
    }
  };

  const renderMoveUp = () => {
    if (props.index > 0) {
      return <MenuItem onClick={(e) => {
        e.stopPropagation();
        handleMoveUp();
        handleMenuClose();
      }}>{TR.cm_move_up}</MenuItem>;
    }
  };

  const renderMoveDown = () => {
    if (props.index < props.count - 1) {
      return <MenuItem onClick={(e) => {
        e.stopPropagation();
        handleMoveDown();
        handleMenuClose();
      }}>{TR.cm_move_down}</MenuItem>;
    }
  };

  const renderMoveToLast = () => {
    if (props.index < props.count - 1) {
      return <MenuItem onClick={(e) => {
        e.stopPropagation();
        handleMoveToBottom();
        handleMenuClose();
      }}>{TR.cm_move_to_bottom}</MenuItem>;
    }
  };

  const renderAccept = () => {
    return <MenuItem onClick={(e) => {
      e.stopPropagation();
      props.onAccept(thisRequest?.id);
      handleMenuClose();
    }}>{TR.cm_accept}</MenuItem>;
  };

  const renderDecline = () => {
    return <MenuItem onClick={(e) => {
      e.stopPropagation();
      props.onDecline(thisRequest?.id);
      handleMenuClose();
    }}>{TR.cm_decline}</MenuItem>;
  };

  const renderMenuButton = () => {
    return <IconButton
      id={"songbook-queue-menu-button-" + thisRequest?.performance?.unique_id}
      color="white"
      component="label"
      size="small"
      aria-controls={isMenuOpen ? "songbook-queue-menu-" + thisRequest?.performance?.unique_id : undefined}
      aria-haspopup="true"
      aria-expanded={isMenuOpen ? 'true' : undefined}
      onClick={(e) => {
        e.stopPropagation();
        openMenu(e);
      }} >
      <MenuIcon />
    </IconButton>;
  };

  const renderPerformancesCount = () => {
    let count = getSingerPerformancesCount();
    if (count) {
      if (count > 0) {
        return <Tooltip title={TR.cm_number_of_songs_by_singer}><span>[{count}]</span></Tooltip>;
      }
    }
  };

  const getSingerPerformancesCount = () => {
    const name = thisRequest?.performance?.profile?.name;
    return (playQueue?.items || []).reduce((acc, item) => {
      const itemName = item?.profile?.name;
      if (itemName === name) acc++;
      return acc;
    }, 0);
  };

  const getIpCount = () => {
    if(!queue) return
    const ip = thisRequest?.ip;
    if(!ip) return 0
    return (queue || []).reduce((acc, item) => {
      const itemIp = item?.ip;
      if (itemIp === ip) acc++;
      return acc;
    }, 0);
  };

  const getIdCount = () => {
    if(!queue) return
    const id = thisRequest?.device_id;
    if(!id) return 0
    return (queue || []).reduce((acc, item) => {
      const itemId = item?.device_id;
      if (itemId === id) acc++;
      return acc;
    }, 0);
  };

  const getHistoryIpCount = () => {
    if(!history) return
    const ip = thisRequest?.ip;
    if(!ip) return 0
    return (history || []).reduce((acc, item) => {
      const itemIp = item?.ip;
      if (itemIp === ip) acc++;
      return acc;
    }, 0);
  };

  const getHistoryIdCount = () => {
    if(!history) return
    const id = thisRequest?.device_id;
    if(!id) return 0
    return (history || []).reduce((acc, item) => {
      const itemId = item?.device_id;
      if (itemId === id) acc++;
      return acc;
    }, 0);
  };

  const primaryText = () => {
    return <span><span className="muvika-bold-title">{thisRequest?.performance?.profile.name} {renderPerformancesCount()}</span> - {thisRequest?.performance?.track.title}</span>;
  };

  const secondaryText = () => {
    return <span><Tooltip title={TR.cm_song_requester_ip_and_amount}><span className="muvika-songbook-queue-item">IP {thisRequest?.ip} ({history ? getIpCount()+getHistoryIpCount() : getIpCount()})</span></Tooltip>, <Tooltip title={TR.cm_song_requester_device_id_and_amount}><span  className="muvika-songbook-queue-item">ID {thisRequest?.device_id?.substring(0, 5)} ({history ? getIdCount()+getHistoryIdCount() : getIdCount()})</span></Tooltip></span>;
  };

  const lengthToMinutes = (length) => {
    const splitted = length.split(":");
    if (splitted.length == 3) {
      return splitted[1] + ":" + splitted[2];
    }
  };

  return (
    <Draggable key={props.key} draggableId={props.draggableId} index={props.index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <ListItemButton selected={props.isSelected} onClick={props.onSelected}>
            <FormControlLabel control={<Checkbox checked={props.isSelected ? true : false} />} />
            <Tooltip title={thisRequest?.performance?.profile.name + " - " + thisRequest?.performance?.track.title}>
            <ListItemText primary={primaryText()} secondary={thisRequest?.performance?.track.artist + " (" + lengthToMinutes(thisRequest?.performance?.track.length) + ")"} />
            </Tooltip>
            <ListItemText
              className="muvika-list-right"
              primary={
                dayjs(thisRequest?.created).format('YYYY-MM-DD HH:mm')
              }
              secondary={secondaryText()}
            />
            {renderMenuButton()}
            <Menu disableAutoFocus disableEnforceFocus disableRestoreFocus
              id={"songbook-queue-menu-" + thisRequest?.performance?.unique_id}
              open={isMenuOpen}
              anchorEl={anchorEl}
              onClose={(e) => {

                e.stopPropagation();
                handleMenuClose();
              }}
              MenuListProps={{
                'aria-labelledby': 'songbook-queue-menu-button-' + thisRequest?.performance?.unique_id,
              }}
            >
              {renderMoveToFirst()}
              {renderMoveToSecond()}
              {renderMoveUp()}
              {renderMoveDown()}
              {renderMoveToLast()}
              {renderAccept()}
              {renderDecline()}
            </Menu>
          </ListItemButton>
        </div>
      )}
    </Draggable>
  );
};

export default SongbookQueueItem;